export default {
  name: 'British Indian Ocean Territory',
  phonePattern: '',
  postalCodePattern: '',
  singlePostalCode: 'BBND1ZZ',
  postalCodeRegex: '^(BBND1ZZ)$',
  language: '',
  dobFormat: 'DD MM YY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/IO.js